/**
 * Shown on Account and elsewhere. Prefer setting `REACT_APP_VERSION` in `.env.local` for accurate builds; otherwise falls back to package alignment (update when you bump package.json).
 */
export const APP_VERSION = process.env.REACT_APP_VERSION?.trim() || '1.0.0';
